import React from "react";
import { Table } from "rsuite";

const { Cell } = Table;

export default function CompanyRole({ rowData, ...props }) {
  return (
    <Cell {...props}>
      {`${rowData.Roles.filter((r) => r.Id !== 6 && r.Id !== 8)
        .map((e) => (e.Name ? e.Name : e.Description))
        .join(", ")}`}
    </Cell>
  );
}
